// import { useCallback, useEffect, useState } from 'react'
// import { useAtom, useSetAtom } from 'jotai'

// import { HttpCode, Millisecond, STORAGE_KEY } from '@/constants/common'
// import { deleteUrlParams, getUrlParams } from '@/lib/utils'
// import { useGlobalMethodProviderContext } from '@/providers/GlobalMethodProvider'
// import { twitterAuthStateAtom } from '@/stores/services'

// import useFetch, { Method } from './useFetch'
// import { useToken } from './useLoginWallet'

import { useAtom } from 'jotai'

import { HttpCode, Millisecond } from '@/constants/common'
import { twitterAuthStateAtom } from '@/stores/services'

import useFetch, { Method, useMutation } from './useFetch'
import { useToken } from './useLoginWallet'

export enum TwitterAuthState {
  UN_KNOWN = 'UN_KNOWN',
  REDIRECTING = 'REDIRECTING',
  AUTHENTICATED = 'AUTHENTICATED',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  EXPIRED = 'EXPIRED',
  OCCUPIED = 'OCCUPIED',
  FAILED = 'FAILED'
}

export const useTwitterAuthCallback = () => {
  const { trigger, ...rest } = useMutation({
    url: '/task/x/auth/callback',
    method: Method.POST
  })

  return {
    trigger,
    ...rest
  }
}

export const useGetTwitterAuthLink = () => {
  const { trigger, ...rest } = useMutation({
    url: '/task/x/auth/link',
    method: Method.POST
  })

  return {
    trigger,
    ...rest
  }
}

export const useCheckTwitterAuth = () => {
  const [twitterAuthState, setTwitterAuthState] = useAtom(twitterAuthStateAtom)

  const { trigger, ...rest } = useMutation({
    url: '/task/check/interact',
    method: Method.POST,
    payload: undefined,
    config: undefined,
    options: {
      onSuccess: (data) => {
        if (data.code === HttpCode.TwitterAuthExpired) {
          setTwitterAuthState(TwitterAuthState.EXPIRED)
        } else if (data.code === 0) {
          setTwitterAuthState(TwitterAuthState.AUTHENTICATED)
        } else {
          setTwitterAuthState(TwitterAuthState.UNAUTHENTICATED)
        }
      }
    },
  })

  return {
    trigger,
    ...rest
  }
}

// export const useCheckTwitterAuth = () => {
//   const { token } = useToken()
//   const [twitterAuthState, setTwitterAuthState] = useAtom(twitterAuthStateAtom)

//   return useFetch<null>(
//     token ? '/task/check/interact' : null,
//     Method.POST,
//     undefined,
//     {
//       onSuccess: (_, code) => {
//         if (code === HttpCode.TwitterAuthExpired) {
//           setTwitterAuthState(TwitterAuthState.EXPIRED)
//         } else if (code === 0) {
//           setTwitterAuthState(TwitterAuthState.AUTHENTICATED)
//         } else {
//           setTwitterAuthState(TwitterAuthState.UNAUTHENTICATED)
//         }
//       }
//     },
//     undefined,
//     {
//       // refreshInterval:
//       //   twitterAuthState === TwitterAuthState.REDIRECTING
//       //     ? Millisecond.SECOND_1
//       //     : undefined
//       refreshInterval: undefined
//     }
//   )
// }

// export const useAuthCallback = () => {
//   const { token } = useToken()
//   const setTwitterAuthState = useSetAtom(twitterAuthStateAtom)
//   const { refreshUserInfo, openTwitterAuth } = useGlobalMethodProviderContext() || {}
//   const [state, code, type] = [getUrlParams('state'), getUrlParams('code'), getUrlParams('type')]
//   const isCallback = type === 'x'

//   const { data, ...rest } = useFetch<any>(
//     token && isCallback && state && code ? '/task/x/auth/callback' : null,
//     Method.POST,
//     { state, code },
//     {
//       onSuccess: (_, code) => {
//         if (code === 0) {
//           setTwitterAuthState(TwitterAuthState.AUTHENTICATED)
//           deleteUrlParams(['state', 'code', 'type'])
//           refreshUserInfo()
//         } else if (code === HttpCode.TwitterOccupied) {
//           setTwitterAuthState(TwitterAuthState.OCCUPIED)
//         } else {
//           setTwitterAuthState(TwitterAuthState.EXPIRED)
//         }
//       }
//     }
//   )

//   useEffect(() => {
//     if (isCallback && state && code) openTwitterAuth?.()
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [])

//   return {
//     state,
//     code,
//     data,
//     ...rest
//   }
// }

// export const useGetAuthLink = () => {
//   const { token } = useToken()
//   const [canFetch, setCanFetch] = useState(false)
//   const [, setTwitterAuthState] = useAtom(twitterAuthStateAtom)

//   const { mutate } = useFetch<{ authUrl: string }>(
//     token && canFetch ? '/task/x/auth/link' : null,
//     Method.POST,
//     { domainType: 1 },
//     {
//       onSuccess: (data) => {
//         if (!data.authUrl) return
//         setTwitterAuthState(TwitterAuthState.REDIRECTING)
//         window.localStorage.setItem(
//           STORAGE_KEY.BEFORE_AUTH_ROUTE,
//           location.pathname
//         )
//         location.href = data.authUrl
//         // window.open(
//         //   data.authUrl,
//         //   '_self',
//         //   'width=500,height=800,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
//         // )
//       }
//     }
//   )

//   const getAuthLink = useCallback(() => {
//     if (!canFetch) setCanFetch(true)
//     else {
//       mutate()
//     }
//   }, [canFetch, mutate])

//   return { getAuthLink }
// }

// export const useTwitterAuth = () => {
//   const { getAuthLink } = useGetAuthLink()
//   const { state, code, isLoading, isValidating } = useAuthCallback()

//   return { state, code, checkLoading: isLoading || isValidating, getAuthLink }
// }
